import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CachedUserLookupItem {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  email: string;
  tenantId: string | null;
  tenantName: string;
}

export type UsersLookupState = Record<string, CachedUserLookupItem>;

interface AppState {
  ready: boolean;
  globalLoadingCount: number;
  usersLookup: UsersLookupState;
  usersLookupUpdatedAt: number | null;
}

const initialState: AppState = {
  ready: true,
  globalLoadingCount: 0,
  usersLookup: {},
  usersLookupUpdatedAt: null,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setReady: (state, action: PayloadAction<boolean>) => {
      state.ready = action.payload;
    },
    startGlobalLoading: (state) => {
      state.globalLoadingCount += 1;
    },
    stopGlobalLoading: (state) => {
      state.globalLoadingCount = Math.max(0, state.globalLoadingCount - 1);
    },
    setUsersLookup: (state, action: PayloadAction<UsersLookupState>) => {
      state.usersLookup = action.payload;
      state.usersLookupUpdatedAt = Date.now();
    },
    clearUsersLookup: (state) => {
      state.usersLookup = {};
      state.usersLookupUpdatedAt = null;
    },
  },
});

export const { setReady, startGlobalLoading, stopGlobalLoading, setUsersLookup, clearUsersLookup } =
  appSlice.actions;
export default appSlice.reducer;
